import { oneKlicks } from "../SDK/oneclick";
import { debugLog } from "../utils/debug";
const updateBalance = async (newAmount, oldAmount = 0, accountId, transaction_id, income, type) => {

    debugLog('newAmount', newAmount);
    debugLog('oldAmount', oldAmount);
    debugLog('accountId', accountId);
    debugLog('transaction_id', transaction_id);
    debugLog('income', income);
    debugLog('type', type);
    try {
        const tableSchema = "";
        const tableName = "balance";
        const conditions = { id: accountId };
        const orderBy = "id DESC";
        const search = {};
        const pagination = {};
        const margedata = [];

        // Get current balance
        const checkbalance = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        
        if (!checkbalance.success || !checkbalance.data || checkbalance.data.length === 0) {
            throw new Error('Unable to fetch current balance');
        }

        // Parse and validate amounts
        const currentBalance = parseFloat(checkbalance.data[0].amount);
        const roundedNewAmount = Math.round(parseFloat(newAmount) * 100) / 100;
        const roundedOldAmount = Math.round(parseFloat(oldAmount || 0) * 100) / 100;
        const roundedCurrentBalance = Math.round(currentBalance * 100) / 100;

        debugLog('roundedNewAmount', roundedNewAmount);     
        debugLog('roundedOldAmount', roundedOldAmount);
        debugLog('roundedCurrentBalance', roundedCurrentBalance);

        let difference = 0;
        let totalbalance = 0;
        let credit = 0;
        let debit = 0;

        if(type === '+'){
            if (roundedOldAmount === 0) {
                totalbalance = roundedCurrentBalance + roundedNewAmount;
                debugLog('totalbalance', totalbalance);
                credit = roundedNewAmount;
            } else if (roundedNewAmount > roundedOldAmount) {
                debugLog('roundedNewAmount > roundedOldAmount new balance', roundedNewAmount);
                difference = roundedNewAmount - roundedOldAmount;
                debugLog('difference', difference);
                totalbalance = roundedCurrentBalance + difference;
                debugLog('totalbalance', totalbalance);
                credit = difference;
            } else if (roundedNewAmount < roundedOldAmount) {
                debugLog('roundedNewAmount < roundedOldAmount new balance', roundedNewAmount);
                difference = roundedOldAmount - roundedNewAmount;
                debugLog('difference', difference);
                totalbalance = roundedCurrentBalance - difference;
                debugLog('totalbalance', totalbalance);
                debit = difference;
            } else {
                return { success: true }; // No change needed
            }
        }else if(type === '-'){
            if (roundedOldAmount === 0) {
                totalbalance = roundedCurrentBalance - roundedNewAmount;
                debugLog('totalbalance', totalbalance);
                credit = roundedNewAmount;
            } else if (roundedNewAmount > roundedOldAmount) {
                debugLog('roundedNewAmount > roundedOldAmount new balance', roundedNewAmount);
                difference = roundedNewAmount - roundedOldAmount;
                debugLog('difference', difference);
                totalbalance = roundedCurrentBalance - difference;
                debugLog('totalbalance', totalbalance);
                credit = difference;
            } else if (roundedNewAmount < roundedOldAmount) {
                debugLog('roundedNewAmount < roundedOldAmount new balance', roundedNewAmount);
                difference = roundedOldAmount - roundedNewAmount;
                debugLog('difference', difference);
                totalbalance = roundedCurrentBalance + difference;
                debugLog('totalbalance', totalbalance);
                debit = difference;
            } else {
                return { success: true }; // No change needed
            }
        }
        

        if (totalbalance < 0) {
            throw new Error('Insufficient balance for this transaction');
        }

        debugLog('update balance totalbalance', totalbalance);

        // Update balance table
        const updatebalance = await oneKlicks.update(tableSchema, tableName, { amount: totalbalance }, conditions);
        if (!updatebalance.success) throw new Error('Failed to update balance');

        // Update balance sheet
        const balanceSheetData = {
            account_id: accountId,
            credit: type === '+' ? roundedNewAmount : 0,
            debit: type === '-' ? roundedNewAmount : 0,
            balance: totalbalance,
            date: income?.date || new Date().toISOString().split("T")[0],
            description: `Income update: ${income?.notes || 'No description'}`,
            status: "active",
            transaction_id: transaction_id,
            type: type === '+' ? 'credit' : 'debit'
        };
        const conditionsSheet = { transaction_id: transaction_id };

        const balanceSheetUpdate = await oneKlicks.update(tableSchema, "balance_sheet", balanceSheetData, conditionsSheet);
        if (!balanceSheetUpdate.success) {
            await oneKlicks.update(tableSchema, tableName, { amount: roundedCurrentBalance }, conditions);
            throw new Error('Failed to update balance sheet');
        }

        return { success: true };
    } catch (error) {
        debugLog('Balance Update Error:', error);
        throw error;
    }
};


export default updateBalance;
